<div class="card mb-5 mb-xl-8">

  <div class="card-header border-0 pt-4">
    <button type="button" class="btn btn-sm btn-success"
            (click)="create()">Create payment
    </button>
  </div>

  <div class="card-body py-3">
    <div class="table-responsive">
      <table datatable class="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
        <thead>
        <tr class="fw-bolder text-muted">
          <th class="min-w-30px" (click)="sortBy('index')" align="left">Index</th>
          <th class="min-w-30px" (click)="sortBy('id')" align="left">Id</th>
          <th class="min-w-90px" (click)="sortBy('startPeriod')" align="left">StartPeriod</th>
          <th class="min-w-90px" (click)="sortBy('endPeriod')">EndPeriod</th>
          <th class="min-w-80px" (click)="sortBy('name')">Name</th>
          <th class="min-w-50px" (click)="sortBy('subtotal')">Subtotal</th>
          <th class="min-w-50px" (click)="sortBy('tax')">Tax</th>
          <th class="min-w-80px" (click)="sortBy('user')">User</th>
          <th class="min-w-80px text-end" scope="col" colspan="2">Actions</th>
        </tr>
        <tr>
          <td>
            <input type="text" class="form-control ng-untouched ng-pristine ng-valid" placeholder="Index">
          </td>
          <td>
            <input type="text"
                   class="form-control ng-untouched ng-pristine ng-valid"
                   placeholder="Id"
                   [(ngModel)]="searchId"
                   (input)="changeFilterValue('id', searchId)">
          </td>
          <td>
            <input type="text"
                   class="form-control ng-untouched ng-pristine ng-valid"
                   placeholder="StartPeriod"
                   [(ngModel)]="searchStartPeriod"
                   (input)="changeFilterValue('startPeriod', searchStartPeriod)">
          </td>
          <td>
            <input type="text"
                   class="form-control ng-untouched ng-pristine ng-valid"
                   placeholder="EndPeriod"
                   [(ngModel)]="searchEndPeriod"
                   (input)="changeFilterValue('endPeriod', searchEndPeriod)">
          </td>
          <td>
            <input type="text"
                   class="form-control ng-untouched ng-pristine ng-valid"
                   placeholder="Name"
                   [(ngModel)]="searchName"
                   (input)="changeFilterValue('name', searchName)">
          </td>
          <td>
            <input type="text"
                   class="form-control ng-untouched ng-pristine ng-valid"
                   placeholder="SubTotal"
                   [(ngModel)]="searchSubTotal"
                   (input)="changeFilterValue('subTotal', searchSubTotal)">
          </td>
          <td>
            <input type="text"
                   class="form-control ng-untouched ng-pristine ng-valid"
                   placeholder="Tax"
                   [(ngModel)]="searchTax"
                   (input)="changeFilterValue('tax', searchTax)">
          </td>
          <td>
            <input type="text"
                   class="form-control ng-untouched ng-pristine ng-valid"
                   placeholder="User"
                   [(ngModel)]="searchUser"
                   (input)="changeFilterValue('user', searchUser)">
          </td>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let payment of payments  |
                  paginate: { itemsPerPage: pageSize,
                                   currentPage: page,
                                   totalItems: count } ;
                  let i = index">
          <td>{{(pageSize * (page - 1)) + i + 1}}</td>
          <td>{{payment.id}}</td>
          <td>{{payment.startPeriod | date:'yy-MM-dd HH:mm'}}</td>
          <td>{{payment.endPeriod | date:'yy-MM-dd HH:mm'}}</td>
          <td>{{payment.name}}</td>
          <td>{{payment.subTotal}}</td>
          <td>{{payment.tax}}</td>
          <td>{{payment.user.email}}</td>
          <td class="tableButton">
            <div class="d-flex justify-content-end flex-shrink-0">
              <button type="button" class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                      (click)="edit(payment.id)"
                      title="Edit the payment">
              <span
                [inlineSVG]="'./assets/media/icons/duotune/art/art005.svg'"
                class="svg-icon svg-icon-2"></span>
              </button>
              <button type="button" class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                      (click)="delete(payment.id)"
                      title="Delete the payment">
              <span
                [inlineSVG]="'./assets/media/icons/duotune/general/gen027.svg'"
                class="svg-icon svg-icon-2">
              </span>
              </button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="pagination">
        <pagination-controls
          previousLabel="Prev"
          nextLabel="Next"
          responsive="true"
          (pageChange)="handlePageChange($event)"
        ></pagination-controls>
      </div>
    </div>
  </div>
</div>

<div [hidden]="!alert" class="alert alert-primary" role="alert">
  {{alertMessage}}
</div>
